import script from "./TelevisionOptionCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TelevisionOptionCard.vue?vue&type=script&lang=ts&setup=true"

import "./TelevisionOptionCard.vue?vue&type=style&index=0&id=3331c5c3&lang=scss"

const __exports__ = script;

export default __exports__